import {ElectronicAuctionItems} from '../services/resources';

const state = {};

const mutations = {};

const actions = {
    getElectronicAuctionItems(context, pagination) {
        return ElectronicAuctionItems.getElectronicAuctionItems(pagination).then((response) => {
            return response.data;
        });
    },
};

const module = {
    state,
    mutations,
    actions
};

export default module;
